export const formatOrgNumber = (orgNr: string) => {
  if (orgNr === '') {
    // To make unit tests cleaner
    return '';
  }
  if ([...orgNr].some(char => !isNumber(char))) {
    return orgNr;
  }
  return `${orgNr.slice(0, -4)}-${orgNr.slice(-4)}`;
};

const isNumber = (char: string) => {
  return /^\d$/.test(char);
};
